module.exports = __webpack_public_path__ + "img/med-in-mind.4dc53f17.svg";